module.exports = __webpack_public_path__ + "static/workflow-automation-03c65845585bd84304bf59116207361b.png";